import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import RewardItem from './RewardSchema';
import { getUserLucky } from '../callGraphql';
import { Box, Flex } from '@chakra-ui/react';

const StyledWrap = styled.div`
  width: 100%;
  overflow: auto;
`;

const THItem = styled.th`
  padding: 10px 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: none;
  font-family: inherit;
  margin-left: 20px;
  color: #fff;
`;

const StyledHeadingTR = styled.tr`
  background-color: var(--card-color);
  height: 50px;
  border-radius: 6px;
`;

const StyledTable = styled.table`
  width: 100%;
  border: 2px solid var(--card-color);
  overflow: auto;
`;

const WrapBox = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
`;

export default function RewardSchema() {
  const { walletAddress } = useSelector((state) => state);
  const [data , setData] = useState(null);

  useEffect(()=>{
    const init = async ()=>{
      const result = await getUserLucky(walletAddress)
      setData(result?.luckyByAddress)
    }
    init()
  }, [walletAddress])

  return (
    <StyledWrap>
      <WrapBox>
        <StyledTable>
          <thead>
            <StyledHeadingTR>
              <THItem>Wallet Address</THItem>
              <THItem>Name Pool</THItem>
              <THItem>Name Round</THItem>
              <THItem>Name Reward</THItem>
            </StyledHeadingTR>
          </thead>
          <tbody>
            {Array.isArray(data) &&
              data?.map((item, index) => {
                return <RewardItem key={index} item={item} rank={index} />;
              })}
          </tbody>
        </StyledTable>
        {(!data || data.length === 0) && (
          <Flex justify='center' flexDirection='column' align='center'>
            <Box fontSize='20px' color='#8e8e91' mt='1rem'>
              Comming soon
            </Box>
          </Flex>
        )}
      </WrapBox>
    </StyledWrap>
  );
}
